export default class extends Controller {
  static targets = ["button", "error"];

  updateStatus(event) {
    event.preventDefault();
    const link = event.target;
    const statusKey = link.dataset.statusKey
    const statusText = link.dataset.statusText
    if (!this.shouldDisplayIncompleteWarning || confirm(this.confirmMessage)) {
      this.pendingStatus = { text: statusText, key: statusKey }
      App.Helpers.ajaxRequest({
        url:            this.updateURL,
        method:         "PUT",
        data:           { status_key: statusKey },
        successHandler: this.updateCurrentStatus.bind(this),
        errorHandler:   this.revertStatus.bind(this)
      });
    }
  }

  doNothing(event) {
    event.preventDefault();
  }

  //
  // INTERNAL USE
  //

  updateCurrentStatus() {
    this.currentStatus = this.pendingStatus;
  }

  revertStatus() {
    this.changeButtonTo(this.currentStatusText, this.currentStatusKey);
  }

  changeButtonTo(text, key, isPending=false) {
    this.buttonTarget.innerText = text;
    this.buttonTarget.className = `dropdown-toggle${isPending ? " pending " : " "}status-${key}`;
  }

  //
  // GETTERS AND SETTERS
  //

  get currentStatusText() {
    return this.data.get("current-status-text");
  }

  get currentStatusKey() {
    return this.data.get("current-status-key")
  }

  set currentStatus({ key, text }) {
    this.data.set("current-status-text", text);
    this.data.set("current-status-key", key);
    this.changeButtonTo(text, key);
  }

  get updateURL() {
    return this.data.get("update-url");
  }

  get shouldDisplayIncompleteWarning() {
    return this.data.get("display-incomplete-work-warning") == "1";
  }

  get confirmMessage() {
    return "This activity still has incomplete work associated with it. Are you sure you want to mark it as Complete?";
  }

  get pendingStatus() {
    return { text: this.data.get("pending-status-text"), key: this.data.get("pending-status-key") }
  }

  set pendingStatus({ text, key }) {
    this.data.set("pending-status-text", text);
    this.data.set("pending-status-key", key);
    this.changeButtonTo(text, key, true);
  }
};



// WEBPACK FOOTER //
// ./app/components/statusables/assets/javascript/statusables-status-button-controller.js